import { createFileRoute, redirect } from "@tanstack/react-router"

import { AuthenticatedLayout } from "#pages/authenticated/layout.tsx"

export const Route = createFileRoute("/_authenticated/$slug")({
  beforeLoad: ({ context, params, location }) => {
    if (context.userInfo.state !== "LoggedIn") {
      throw redirect({ to: "/sign-in" })
    }

    const { slug } = context.userInfo.me.organization
    if (params.slug !== slug) {
      throw redirect({
        href: `${location.pathname.replace(/^\/[^/]*/, `/${slug}`)}${location.searchStr}`,
        replace: true,
      })
    }
  },
  component: AuthenticatedLayout,
})
